import * as $ from "jquery";
import "waypoints/lib/jquery.waypoints.js";

var $section = $("main > section");
var $productNavigation = $("#teamsNavigation");
var $navigationLinkParents = $productNavigation.find(".item-linkButtonImage");
var $navigationLinks = $navigationLinkParents.find("a");
var $navButton = $productNavigation.find(".button");

var navHeight = $productNavigation.outerHeight();
var windowWidth = $(window).width();

var TABLET_BREAKPOINT = 800;
var PRODUCT_SECTION_CLASS = "teams-product-section";
var ACTIVE_CLASS = "active";
var BUTTON_HIDDEN_CLASS = "hidden";

$(window).resize(function () {
  windowWidth = $(window).width();
});

$navigationLinks.click(function () {
  var id = $(this).attr("href");
  scrollToId(id, 300);
  return false;
});

function scrollToId(id: string, speed: number) {
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top - navHeight / 2, // cut offset in half
    },
    speed
  );
}

// Screens less or equal to than breakpoint width
if (windowWidth <= TABLET_BREAKPOINT) {
  $(window).on("scroll touchmove", function () {
    var scrollPosition = $(this).scrollTop();

    $section.each(function () {
      var top = $(this).offset().top - navHeight,
        bottom = top + $(this).outerHeight();

      if (scrollPosition >= top && scrollPosition <= bottom) {
        if ($(this).hasClass(PRODUCT_SECTION_CLASS)) {
          $navButton.addClass(BUTTON_HIDDEN_CLASS);
          $navigationLinkParents.removeClass(ACTIVE_CLASS);
          $productNavigation
            .find('a[href="#' + $(this).attr("id") + '"]')
            .parent()
            .addClass(ACTIVE_CLASS);
        } else {
          $navigationLinkParents.removeClass(ACTIVE_CLASS);
          $navButton.removeClass(BUTTON_HIDDEN_CLASS);
        }
      }
    });
  });
} else {
  $(window).on("scroll touchmove", function () {
    var scrollPosition = $(this).scrollTop();

    $section.each(function () {
      var top = $(this).offset().top - navHeight,
        bottom = top + $(this).outerHeight();

      if (scrollPosition >= top && scrollPosition <= bottom) {
        $productNavigation.find("a").removeClass(ACTIVE_CLASS);

        if ($(this).hasClass(PRODUCT_SECTION_CLASS)) {
          $productNavigation
            .find('a[href="#' + $(this).attr("id") + '"]')
            .addClass(ACTIVE_CLASS);
        }
      }
    });
  });
}

// Image Slide-up
$(window).load(function () {
  if ($(".products__image").find("img").length) {
    var slideUpTrigger = $(".products__image").find("img");
    var imageMidPoint = slideUpTrigger.outerHeight() / 2;

    new Waypoint({
      element: slideUpTrigger,
      handler: function () {
        slideUpTrigger.addClass("slide-up");
      },
      offset: window.innerHeight - imageMidPoint,
    });
  }
});

// Read more link, expand text and remove link
$(window).load(async function () {
  await import("jquery-migrate");
  await import("jquery-dotdotdot/src/jquery.dotdotdot.js");

  $(".p--readmore p").dotdotdot();
  $(".p--readmore-link").on("click", function (event) {
    event.preventDefault();
    $(this).remove();
    var $readMoreText = $(".p--readmore p");
    $readMoreText.addClass("open");

    //  ...or by using the callback function
    $readMoreText.trigger("originalContent", function (content) {
      $readMoreText.text("");
      $readMoreText.append(content);
    });
    return false;
  });
});
